export default "__VITE_ASSET__W$bm4cCx__"